import { render, staticRenderFns } from "./TenantSwitcher.vue?vue&type=template&id=1f28106a"
import script from "./TenantSwitcher.vue?vue&type=script&lang=ts"
export * from "./TenantSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./TenantSwitcher.vue?vue&type=style&index=0&id=1f28106a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports